/**
 * @项目名称: cardloan-h5
 * @文件名称: getQueryJson.js
 * @Date 17/12/19.
 * @Author liux
 * @Copyright（C）: 小赢科技 Inc. All rights reserved.
 * 注意：本内容仅限于小赢科技内部传阅，禁止外泄以及用于其他的商业目的。

 * 获取url 查询参数，默认执行时当前 url
 */
function getQueryJson(url) {
  url = url || location.search;
  var result = {};
  var index = url.indexOf("?");
  if ( index != -1) {
    var str = url.substr(index+1);
    var arr = str.split("&");
    arr.forEach(function (item) {
      var tmp =  item.split('=');
      result[tmp[0]] = (tmp[1] != undefined)?decodeURIComponent(tmp[1]):'';
    })
  }
  return result;
}
export default getQueryJson
